// extracted by mini-css-extract-plugin
module.exports =  {"table":"Br_unNg6EwNcuKyeXHrZ","alert":"PtCc2UIrQ_CJ7h1exddC","container":"vV7HQXn14nqy9zc_asH4"};